var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload2 = function SvgUpload2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 21,
    "data-width-40": 37,
    viewBox: "0 0 12.9 11",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M3.966 8.312H2.404c-2.5 0-2.577-4.062 0-4.062.069 0 0-3.75 4.062-3.75 3.596 0 3.666 3.125 3.75 3.125 2.813 0 2.813 4.688 0 4.687h-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.216 6.437 1.25-1.562 1.25 1.562M6.466 4.875V10.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload2);
export default ForwardRef;